import React from 'react'
import { Link } from 'react-router-dom'
import './anchor-component.scss'
import { AnchorProps } from '../../types'
import { concatClassName } from '../../utils/helpers'

const Anchor = ({
  text,
  href,
  variant = 'basic-anchor',
  classes,
  dataTestId,
  target = '',
  isDisabled = false,
}: AnchorProps) => {
  return isDisabled ? (
    <Link
      className={`${variant} ${concatClassName(classes)}`}
      to={href}
      onClick={(event) => event.preventDefault()}
      data-testid={dataTestId}
    >
      {text}
    </Link>
  ) : (
    <Link
      className={`${variant} ${concatClassName(classes)}`}
      target={target}
      to={href}
      data-testid={dataTestId}
    >
      {text}
    </Link>
  )
}

const AnchorLabel = ({
  text,
  href,
  variant = 'label-anchor',
  classes,
  IconComponent,
  isDisabled = false,
  underline = false,
}: AnchorProps) => {
  return isDisabled ? (
    <Link
      className={`${variant} ${concatClassName(classes)}`}
      to={href}
      onClick={(event) => event.preventDefault()}
    >
      {IconComponent}{' '}
      <span style={{ textDecoration: underline ? 'underline' : 'none' }}>{text}</span>{' '}
    </Link>
  ) : (
    <Link
      className={`${variant} ${concatClassName(classes)}`}
      target='_blank'
      to={''}
      onClick={(event) => {
        event.preventDefault()
        window.open(href)
      }}
    >
      {' '}
      {IconComponent}{' '}
      <span style={{ textDecoration: underline ? 'underline' : 'none' }}>{text}</span>{' '}
    </Link>
  )
}

export { Anchor, AnchorLabel }
